/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ButtonProps, DIALOG_SIZE_SM_MD, DialogContentProps, DialogProps } from '@squiz/sds';
import { DialogLauncher } from 'apps/console-core/src/Components/DialogLauncher/DialogLauncher';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIGURATION_STRINGS } from '../../../../Constants/Strings.constants';
import { JOB_CONTEXTS_DATA_IDS } from '../../JobContexts.constants';
import { JobContextForm } from '../../forms/JobContextForm/JobContextForm';
import { CreateJobContextProps } from './CreateJobContext.props';

/**
 * The create job context dialog launcher.
 */
export const CreateJobContext = (props: CreateJobContextProps): JSX.Element => {
  const { t } = useTranslation();
  const { clearCache } = props;

  // Labels
  const labels = useMemo(() => {
    return {
      createAContext: t(CONFIGURATION_STRINGS.createAContext),
      createContext: t(CONFIGURATION_STRINGS.createContext),
    };
  }, [t]);

  // Configurations
  const dialogButtonProps: ButtonProps = {
    classes: `create-job-context__launcher`,
    dataId: JOB_CONTEXTS_DATA_IDS.createButton,
    text: labels.createContext,
  };

  const dialogProps = {
    classes: 'create-job-context__dialog',
    dialogContent: {
      renderContent: (dialogContentProps: DialogContentProps): JSX.Element => {
        return <JobContextForm {...dialogContentProps} clearCache={clearCache} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM_MD,
    heading: labels.createAContext,
    scrollOnOverflow: true,
    showDividers: true,
  } as DialogProps;

  return (
    <div className="create-job-context-dialog__wrapper">
      <DialogLauncher buttonProps={dialogButtonProps} dialogProps={dialogProps} />
    </div>
  );
};
